import { render, staticRenderFns } from "./ViewApproval.vue?vue&type=template&id=a4d4d214&"
import script from "./ViewApproval.vue?vue&type=script&lang=js&"
export * from "./ViewApproval.vue?vue&type=script&lang=js&"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./ViewApproval.vue?vue&type=style&index=1&id=a4d4d214&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports